// SPDX-License-Identifier: GPL-2.0-or-later
// Modelo do mapa (src/world.h:53-242): grade de salas com paredes, áreas de chão, bandeiras,
// spawns e áreas de respawn. Construído pelo parser de @outgun/content.
import { noBounce } from '../geometry/bounce.js';
import { Vec } from '../geometry/vec.js';
export class Room {
    /** Paredes, na ordem do arquivo de mapa (a ordem importa para a física). */
    walls = [];
    /** Áreas de chão com textura própria (só visual). */
    ground = [];
    /** Checagem por retângulo; tão precisa quanto `intersectsRect` de cada parede. */
    fallOnWallRect(x1, y1, x2, y2) {
        return this.walls.some((wall) => wall.intersectsRect(x1, y1, x2, y2));
    }
    /** Checagem por círculo; tão precisa quanto `intersectsCirc` de cada parede. */
    fallOnWallCirc(center, r) {
        return this.walls.some((wall) => wall.intersectsCirc(center, r));
    }
    /**
     * Primeiro impacto de um círculo de raio `radius` saindo de `center` com velocidade `vel`, dentro
     * de `maxFraction` frames (`Room::genGetTimeTillWall`, src/world.cpp:347). Paredes fora da caixa
     * do movimento são descartadas antes; empates ficam com a parede que vem antes no arquivo.
     */
    timeTillWall(center, vel, radius, maxFraction) {
        let best = noBounce();
        if (vel.x === 0 && vel.y === 0)
            return best;
        const endX = center.x + vel.x * maxFraction;
        const endY = center.y + vel.y * maxFraction;
        const x0 = Math.min(center.x - radius, endX - radius);
        const y0 = Math.min(center.y - radius, endY - radius);
        const x1 = Math.max(center.x + radius, endX + radius);
        const y1 = Math.max(center.y + radius, endY + radius);
        for (const wall of this.walls) {
            if (!wall.intersectsRect(x0, y0, x1, y1))
                continue;
            best = wall.tryBounce(best, center, vel, radius);
        }
        return best;
    }
}
export class GameMap {
    width;
    height;
    title;
    author;
    crc;
    /** Salas indexadas por [x][y], como no original. */
    rooms;
    /** Times 0 (vermelho) e 1 (azul). */
    teams = [
        { flags: [], spawn: [], respawn: [] },
        { flags: [], spawn: [], respawn: [] },
    ];
    /** Bandeiras selvagens (time 2). */
    wildFlags = [];
    constructor(width, height, title, author, 
    /** CRC-16 do conteúdo significativo do arquivo (`Map::crc`); identifica a versão do mapa. */
    crc) {
        this.width = width;
        this.height = height;
        this.title = title;
        this.author = author;
        this.crc = crc;
        this.rooms = Array.from({ length: width }, () => Array.from({ length: height }, () => new Room()));
    }
    room(coords) {
        const room = this.rooms[coords.x]?.[coords.y];
        if (!room)
            throw new RangeError(`sala fora do mapa: (${coords.x}, ${coords.y})`);
        return room;
    }
    fallOnWallCirc(center, r) {
        return this.room(center.room).fallOnWallCirc(new Vec(center.x, center.y), r);
    }
    fallOnWallRect(rect) {
        return this.room(rect.room).fallOnWallRect(rect.x1, rect.y1, rect.x2, rect.y2);
    }
}
//# sourceMappingURL=map.js.map